// this is ordered by name
// puts Language.where(translate_with_ai: true).order(:name).map { |l| "  #{l.id}: '#{l.name}'," }
// put at the top: 
// EN: 'English (American)',
// EN2: 'English (British)',

const AiLanguages = {
  EN: 'English (American)',
  EN2: 'English (British)',
  SQ: 'Albanian',
  AR: 'Arabic',
  BN: 'Bengali',
  BG: 'Bulgarian',
  ZH: 'Chinese (Simplified)',
  ZH2: 'Chinese (Traditional)',
  HR: 'Croatian',
  CS: 'Czech',
  DA: 'Danish',
  NL: 'Dutch',
  FI: 'Finnish',
  FR: 'French',
  DE: 'German',
  EL: 'Greek',
  IW: 'Hebrew',
  HI: 'Hindi',
  HU: 'Hungarian',
  IN: 'Indonesian',
  IT: 'Italian',
  JA: 'Japanese',
  KO: 'Korean',
  NO: 'Norwegian',
  FA: 'Persian',
  PL: 'Polish',
  PT2: 'Portuguese (Brazilian)',
  PT: 'Portuguese (European)',
  RO: 'Romanian',
  RU: 'Russian',
  SR: 'Serbian',
  SK: 'Slovak',
  ES: 'Spanish',
  SV: 'Swedish',
  TR: 'Turkish',
  UK: 'Ukrainian',
  UZ: 'Uzbek',
  VI: 'Vietnamese',
};

export default AiLanguages;
